
stateAPP.initPageContent = function(){

  var _ = stateAPP;

  if(typeof _ !== 'undefined' && typeof $.fancybox !== 'undefined'){

    if(_.thumbPanelsA.length){

      _.thumbPanelsA.on('click',function(e){

        e.preventDefault();

        var t = $(this);
        var parent = t.parent().parent();

        if(parent.hasClass('thumb-panel')){

          var imageArray = [];
          parent.find('a').each(function(index){
            var t = $(this);
            var href = t.attr('href');
            t.attr('data-index',index);
            imageArray.push(href);
          });

          if(!t.data('index')<0){t.data('index',imageArray.length-1);}
          $.fancybox(imageArray, {index:t.data('index')});

        }
      });
    };

    _.productPhotoImg.on('click',function(e){
      e.preventDefault();
      var t = $(this);
      var rel = t.data('rel');
      if(typeof rel!== 'undefined'){
        $(rel).find('a').eq(6).click();
      }
    });

  }

  if(_.contentP.length){
    _.contentP.each(function(){
      var t = $(this);
      var text = t.html().split(' ');
      var lastWord = text.pop();
      if (text.length <= 1){ return;}
      var content = text.join(' ') + '&nbsp;' + lastWord;
      t.html(content);
    });
  };

  var doLoad = true;
  _.videoPlayer = $('#video-player');

  if(window.innerWidth <= 1024){
    _.videoPlayer.remove(); /* no fade, just remove it */
    doLoad = false;
  }

  if(doLoad){

    _.videoPlayer.addClass('glass');

    _.initVideo = function(){

        

        _.hasScrolled = false;
        _.unveilAllTimeout = window.setTimeout(function(){
          $(window).trigger('scroll');
          $('img').trigger('unveil');
        },30000);

        $(window).scroll(function() {
          var scrollTop = $(window).scrollTop();

          if(!_.hasScrolled){
            window.clearTimeout(_.unveilAllTimeout);
            $('.flexslider').flexslider();
            $('img.lazy, .lazy img').unveil(1200);
            _.hasScrolled = true;

          };

          if(scrollTop>1200 && (window.player.getPlayerState() === 1 || window.player.getPlayerState() === 5)){
           window.player.pauseVideo();
          }else if(scrollTop < 1000 && window.player.getPlayerState() === 2){
            window.player.playVideo();
          }

        });

        /* --------------------------------------------------------- */

        if(_.videoLink.length){
          _.videoLink.on('click',function(e){

            e.preventDefault();
            window.clearTimeout(_.timeout);

            _.videoLink.text('Playing...');

            window.player.pauseVideo();
            window.player.unMute();


            var t = $(this);
            var href= t.attr('href');

            stateAPP.videoHREF = href;

            stateAPP.timeout = setTimeout(function(){
              $.fancybox(stateAPP.videoHREF,{
                type:'iframe',
                afterClose:function(){
                  window.player.mute();
                  window.player.playVideo();
                  _.videoLink.text('Play Video');
                }
              });
            }, 750); /* enable a lengthy pause */

            return false;

          });
        }

      };
  }else{
    
    $('.flexslider').flexslider();
    $('img.lazy, .lazy img').unveil(500);

    if(_.videoLink.length){
      _.videoLink.on('click',function(e){
        e.preventDefault();
        var t = $(this);
        var href= t.attr('href');
        stateAPP.videoHREF = href;
        $.fancybox(stateAPP.videoHREF,{
          type:'iframe'
        });
      });
    }
  }
};

$(function() {

    var tag = document.createElement('script');
    tag.src = "//www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      
    stateAPP.videoLink = $('#videoLaunch');
    stateAPP.thumbPanelsA = $('.thumb-panel a');
    stateAPP.contentP = $('.product-info p');
    stateAPP.productPhotoImg = $('.product-photo img, a.gallery-button');

    stateAPP.initPageContent();
  
});